export default __webpack_public_path__ + "static/media/logo.a88228e2.png";